<template>
  <div class="modal fade slide-up" id="modalCandidateDetail" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog ">
      <div class="modal-content-wrapper">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
            <i class="pg-close"></i>
          </button>
          <div class="modal-body">
            <div class='content-candidate'>
              <div class="form-group form-group-default">
                <label>{{ $t("models.user.last_name") }}</label>
                <div class="form-control">{{ candidate.last_name }}</div>
              </div>
              <div class="form-group form-group-default">
                <label>{{ $t("models.user.first_name") }}</label>
                <div class="form-control">{{ candidate.first_name }}</div>
              </div>
              <div class="form-group form-group-default radio-group">
                <label class="text-transform-unset">{{ $t("SignUpForm.label_internal") }}</label>
                <div class="radio radio-success">
                  <input type="radio" id="yes" name="yes" :value="'intern'" v-model="candidate.resource_type" disabled>
                  <label for="yes">{{ $t('yes') }}</label>
                  <input type="radio" id="no" name="no" :value="'extern'" v-model="candidate.resource_type" disabled>
                  <label for="no">{{ $t('no') }}</label>
                </div>
              </div>
              <div v-if="candidate.affiliated_service" class="form-group form-group-default">
                <label>{{ $t("models.user.affiliated_service") }}</label>
                <div class="form-control">{{ candidate.affiliated_service.name }}</div>
              </div>
              <div class="form-group form-group-default">
                <label>{{ $t("models.user.services") }}</label>
                <div class="multiselect">
                  <div class="multiselect__tags">
                    <div class="multiselect__tags-wrap">
                      <span
                        class="multiselect__tag"
                        v-for="service in candidate.services"
                        :key="`candidate_service_${service.id}`"
                        >
                        {{ service.name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-default">
                <label>{{ $t("models.user.occupations") }}</label>
                <div class="multiselect">
                  <div class="multiselect__tags">
                    <div class="multiselect__tags-wrap">
                      <span
                        class="multiselect__tag"
                        v-for="occupation in candidate.occupations"
                        :key="`candidate_occupation_${occupation.id}`"
                        >
                        {{ occupation.name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="moveToCandidatePage">
              {{ $t("DashboardPageManager.AwaitingPopupCandidateDetail.btn_edit") }}
            </button>
            <button type="button" class="btn btn-primary" @click="activateUser" v-if="candidate.state == 'confirmed'">
              {{ $t("DashboardPageManager.AwaitingPopupCandidateDetail.btn_validate") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AwaitingPopupCandidateDetail',
  props: ['entityId'],
  computed: {
    ...mapGetters({
      candidate: 'dashboard/activeCandidate'
    })
  },
  methods: {
    moveToCandidatePage() {
      this.$router.push({ name: 'EditUser', params: { entity_id: this.entityId, user_id: this.candidate.id } })
      this.closePopup()
    },
    async activateUser() {
      this.$store.dispatch('users/getEntitiesForMultiAction', {
        user: this.candidate ,
        entityId: this.entityId,
        action: 'activate'
      });
      await this.$store.dispatch("dashboard/initDataCandidateBlock", this.entityId);
      this.closePopup()
    },
    closePopup() {
      $('#modalCandidateDetail').modal('hide');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/manager/AwaitingPopupCandidateDetail.vue